<template>
  <div class="pay-day detail-item" v-if="editingData">

    <div class="head"><b>支払い日</b></div>
    <div class="data">
      <p>翌月{{ editingData.pay_day }}日</p>
    </div>

  </div>
</template>

<script lang="ts">
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
